module.exports = __webpack_public_path__ + "static/media/belasting-3.0294033c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-3.svg
// module id = 118
// module chunks = 0